<template>
  <div>
    <div class="mt-5">
      <div>
        <div class="accordion full-width" role="tablist">
          <div class="card">
            <header role="tab" class="p-0">
              <button
                id="scrollto"
                class="btn btn-info btn-block text-left w-100"
                type="button"
                aria-expanded="true"
                aria-controls="accordion-1"
              >
                {{ screentexts[118] ? screentexts[118].element_text : 'Survey participants' }}
              </button>
            </header>
          </div>
          <div id="accordion-1" class="collapse show" role="tabpanel">
            <div class="card-body">
              <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
                <button
                  v-show="surveyStatusId < 4"
                  class="btn btn-primary"
                  @click.prevent="toggleaddmember"
                >
                  {{ screentexts[119] ? screentexts[119].element_text : 'Add survey participant' }}
                </button>
                <button
                  v-show="numberSelectedMembersWithEmail > 0"
                  :disabled="Number(selectedCount) === 0"
                  class="btn btn-secondary"
                  @click.prevent="togglecontactmembers"
                >
                  {{ screentexts[120] ? screentexts[120].element_text : 'Contact' }}
                  {{ numberSelectedMembersWithEmail }}
                  {{ screentexts[121] ? screentexts[121].element_text : 'member' }}<span v-if="numberSelectedMembersWithEmail > 1 || Number(numberSelectedMembersWithEmail) === 0">s</span>
                </button>
                <button
                  v-show="surveyStatusId < 4 && numberSelectedMembersWithEmail > 0"
                  :disabled="Number(selectedCount) === 0"
                  class="btn btn-warning"
                  @click.prevent="togglesendinvitations"
                >
                  {{ screentexts[122] ? screentexts[122].element_text : 'Send' }}
                  {{ numberSelectedMembersWithEmail }}
                  {{ screentexts[123] ? screentexts[123].element_text : 'invitation' }}<span v-if="numberSelectedMembersWithEmail > 1 || Number(numberSelectedMembersWithEmail) === 0">s</span>
                </button>
              </div>

              <div v-if="invitationsSent > 0 && numberSelectedMembersWithEmail === 0" class="alert alert-success mt-2 mb-0 py-2">
                {{ invitationsSent }} invitation<span v-if="invitationsSent > 1">s</span> sent successfully.
              </div>

              <div v-if="addmember" class="mt-3">
                <h4 class="mb-3">{{ screentexts[119] ? screentexts[119].element_text : 'Add survey participant' }}</h4>
                <div class="bg-secondary add-member-container p-3">
                  <form novalidate @submit.stop.prevent>
                    <div class="mb-3">
                      <label class="mb-2 d-block">
                        {{ screentexts[167] ? screentexts[167].element_text : 'Form Type' }}
                      </label>
                      <select
                        :value="groupmember_formoption_id"
                        class="form-select w-100"
                        @change="groupmember_formoption_id = $event.target.value; groupmember_email_valid = null"
                      >
                        <option v-for="option in formoptions" :key="option.value" :value="option.value">{{ option.text }}</option>
                      </select>
                    </div>
                    <div v-show="Number(groupmember_formoption_id) === 1" class="mb-3">
                      <label class="mb-2 d-block">
                        {{ screentexts[164] ? screentexts[164].element_text : 'Email address' }}
                      </label>
                      <input
                        :value="groupmember_email"
                        class="form-control w-100"
                        :class="[anon ? 'g-anon' : '', groupmember_email_valid === 'invalid' ? 'is-invalid' : '']"
                        type="text"
                        :placeholder="screentexts[170] ? screentexts[170].element_text : 'Email Address'"
                        @input="groupmember_email = $event.target.value"
                      >
                      <div v-if="groupmember_email_valid === 'invalid'" class="invalid-feedback d-block">
                        Invalid or duplicate email address
                      </div>
                    </div>
                    <div class="mb-0 mt-4">
                      <div class="d-flex justify-content-end gap-2">
                        <button class="btn btn-primary" @click.prevent="addgroupmember">Add</button>
                        <button class="btn btn-danger" @click.prevent="toggleaddmember">Cancel</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div v-show="contactmembers === true" class="mt-3 bg-secondary add-member-container p-3">
                <h4>
                  {{ screentexts[124] ? screentexts[124].element_text : 'Contact Members' }}
                  {{ screentexts[129] ? screentexts[129].element_text : 'email' }}<span v-if="numberSelectedMembersWithEmail > 1">s</span>
                </h4>
                <p v-if="numberSelectedMembersWithEmail != selectedCount" class="mb-3">
                  Please note: Some selected members do not have an email address and will not be contacted using this function
                </p>
                <form novalidate @submit.stop.prevent>
                  <div class="mb-3">
                    <label class="mb-2">{{ screentexts[131] ? screentexts[131].element_text : 'Email subject' }}</label>
                    <input
                      :value="mail_subject"
                      :placeholder="screentexts[125] ? screentexts[125].element_text : 'Email subject'"
                      class="form-control w-100"
                      @input="mail_subject = $event.target.value"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="mb-2">{{ screentexts[126] ? screentexts[126].element_text : 'Email text' }}</label>
                    <BaseEditor
                      :model-value="mail_consultant_text"
                      :editor-toolbar="editortoolbar"
                      @update:model-value="mail_consultant_text = $event"
                    />
                  </div>
                  <div class="text-right mb-0">
                    <button class="btn btn-danger mr-3" @click.prevent="togglecontactmembers">
                      {{ screentexts[127] ? screentexts[127].element_text : 'Cancel' }}
                    </button>
                    <button class="btn btn-primary" @click.prevent="sendemails('Other')">
                      {{ screentexts[128] ? screentexts[128].element_text : 'Send' }}
                      {{ selectedCount }}
                      {{ screentexts[129] ? screentexts[129].element_text : 'email' }}<span v-if="selectedCount > 1">s</span>
                    </button>
                  </div>
                </form>
              </div>

              <div v-show="sendinvitations === true" class="mt-3 bg-secondary add-member-container p-3">
                <h4>{{ screentexts[130] ? screentexts[130].element_text : 'Send Invitations' }}</h4>
                <p v-if="numberSelectedMembersWithEmail != selectedCount" class="mb-3">
                  Please note: Some selected members do not have an email address and will not be sent the invitation using this function
                </p>
                <form novalidate @submit.stop.prevent>
                  <div class="mb-3">
                    <label class="mb-2">{{ screentexts[131] ? screentexts[131].element_text : 'Email subject' }}</label>
                    <input
                      :value="survey_invitation_subject"
                      :placeholder="screentexts[131] ? screentexts[131].element_text : 'Email subject'"
                      class="form-control w-100"
                      @change="survey_invitation_subject = $event.target.value; saveField('survey_invitation_subject', $event.target.value)"
                    />
                  </div>
                  <div v-if="$store.state.currentsurvey.spotify != 1" class="mb-3">
                    <label class="mb-2">{{ screentexts[155] ? screentexts[155].element_text : 'Invitation e-mail fixed text' }}</label>
                    <div class="text-container">
                      <div id="fixed-text" class="mt-3" v-html="$store.state.currentsurvey.survey_invitation_text" />
                      <div class="d-flex justify-content-end mb-4">
                        <button class="btn btn-primary btn-tinyall" @click="copyText">Copy Text</button>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="mb-2">
                      <span>{{ screentexts[17] ? screentexts[17].element_text : '' }}</span>
                    </label>
                    <BaseEditor
                      id="survey_invitation_consultant_text"
                      :model-value="survey_invitation_consultant_text"
                      :editor-toolbar="editortoolbar"
                      @update:model-value="survey_invitation_consultant_text = $event"
                      @blur="saveField('survey_invitation_consultant_text', survey_invitation_consultant_text)"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="mb-2">{{ screentexts[132] ? screentexts[132].element_text : 'Email replies to' }}</label>
                    <input
                      :value="survey_invitation_cc"
                      :placeholder="screentexts[133] ? screentexts[133].element_text : 'Email reply address'"
                      class="form-control w-100"
                      @change="survey_invitation_cc = $event.target.value; saveField('survey_invitation_cc', $event.target.value)"
                    />
                  </div>
                  <div class="text-right mb-0">
                    <button class="btn btn-danger mr-3" @click.prevent="togglesendinvitations">
                      {{ screentexts[134] ? screentexts[134].element_text : 'Cancel' }}
                    </button>
                    <button class="btn btn-primary" @click.prevent="sendemails('Invitation')">
                      {{ screentexts[135] ? screentexts[135].element_text : 'Send' }}
                      {{ selectedCount }}
                      {{ screentexts[136] ? screentexts[136].element_text : 'Invitation' }}<span v-if="selectedCount > 1">s</span>
                    </button>
                  </div>
                </form>
              </div>

              <BaseTable
                :fields="fields"
                :class="'actions-table save-cancel'"
                :items="includedGroupMembers"
                :tbody-tr-class="rowClass"
                hover
              >
                <template v-slot:head(select)>
                  <input
                    type="checkbox"
                    :checked="selected"
                    class="form-check-input"
                    @click.stop
                    @change="selected = $event.target.checked; $nextTick(() => selectall(selected))"
                  />
                </template>
                <template v-slot:cell(select)="{ data }">
                  <div class="d-flex justify-content-center align-items-center">
                    <input
                      v-if="isIncluded(data.item)"
                      type="checkbox"
                      :checked="data.item.selected"
                      class="form-check-input m-0"
                      @click.stop
                      @change="data.item.selected = $event.target.checked; countselected()"
                    />
                  </div>
                </template>
                <template v-slot:cell(actions)="{ data }">
                  <div class="d-flex justify-content-end align-items-center">
                    <div v-if="data.item.editable" class="d-flex">
                      <button class="btn btn-danger btn-tiny mr-1" @click.prevent="cancelEdit(data.item.id)">Cancel</button>
                      <button class="btn btn-primary btn-tiny" @click.prevent="saveEdit(data.item.id)">Save</button>
                    </div>
                    <div v-else class="ellipsis-button">
                      <BaseDropdown right variant="link">
                        <template #button-content>
                          <i class="fa-solid fa-ellipsis"></i>
                        </template>
                        <li><a class="dropdown-item" href="#" @click.prevent="editGroupMember(data.item.id)">Edit</a></li>
                        <li v-if="canExcludeMembers"><a class="dropdown-item" href="#" @click.prevent="togglegroupmember(data.item.id)">Exclude from this survey</a></li>
                        <li v-if="data.item.groupsurveymember_formoption_id != 2"><a class="dropdown-item" href="#" @click.prevent="getlink(data.item.id)">Copy invitation</a></li>
                        <li v-if="Number(data.item.groupsurveymember_formoption_id) === 2"><a class="dropdown-item" href="#" @click.prevent="printform(data.item.id)">Print form</a></li>
                        <li v-if="Number(data.item.groupsurveymember_formoption_id) === 2"><a class="dropdown-item" href="#" @click.prevent="openquestionnaire(data.item.id)">Open survey</a></li>
                        <li v-if="Number(data.item.groupsurveymember_formoption_id) === 1 && surveyStatusId < 4"><a class="dropdown-item" href="#" @click.prevent="toggleSelected(data.item.id, 'scrollto', 'invite')">Send invitation</a></li>
                        <li v-if="Number(data.item.groupsurveymember_formoption_id) === 1"><a class="dropdown-item" href="#" @click.prevent="toggleSelected(data.item.id, 'scrollto', 'contact')">Contact member</a></li>
                      </BaseDropdown>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(groupsurveymember_status_id)="{ data }">
                  <div v-if="isIncluded(data.item)" class="d-flex align-items-center">
                    <span :class="statusBadgeClass(data.item)">{{ statusLabel(data.item) }}</span>
                  </div>
                  <div v-else class="text-muted small">Not participating</div>
                </template>
                <template v-slot:cell(groupsurveymember_survey_code)="{ data }">
                  {{ data.item.groupsurveymember_survey_code }}
                </template>
                <template v-slot:cell(groupmember_email)="{ data }">
                  <div class="position-relative">
                    <div v-if="!data.item.editable" class="uneditable" :class="{ 'g-anon': anon }">{{ data.item.groupmember_email }}</div>
                    <input
                      v-else
                      v-model="data.item.groupmember_email"
                      type="text"
                      class="form-control"
                      :class="{ 'g-anon': anon, 'text-danger': data.item.groupmember_email_valid === 'invalid' }"
                    />
                    <i
                      v-if="data.item.groupmember_email_valid === 'invalid' && data.item.editable"
                      class="fa-solid inline-tooltip fa-circle-question tooltip-question tooltip-danger"
                      title="Invalid email address"
                    ></i>
                  </div>
                </template>
                <template v-slot:cell(groupmember_mobile)="{ data }">
                  <input v-model="data.item.groupmember_mobile" type="text" class="form-control" />
                </template>
                <template v-slot:cell(groupsurveymember_formoption_id)="{ data }">
                  <div v-if="!data.item.editable" class="uneditable">{{ getFormOptionText(data.item.groupsurveymember_formoption_id) }}</div>
                  <select
                    v-else-if="Number(data.item.groupsurveymember_status_id) === 1"
                    v-model="data.item.groupsurveymember_formoption_id"
                    class="form-select"
                  >
                    <option v-for="option in formoptions" :key="option.value" :value="option.value">{{ option.text }}</option>
                  </select>
                  <div v-else class="uneditable">{{ getFormOptionText(data.item.groupsurveymember_formoption_id) }}</div>
                </template>
              </BaseTable>

              <h3 class="mt-4">Members not included in survey</h3>
              <BaseTable
                :fields="fieldsExclude"
                :class="'actions-table save-cancel excluded mb-5'"
                :items="excludedGroupMembers"
                :tbody-tr-class="rowClass"
                hover
              >
                <template v-slot:cell(actions)="{ data }">
                  <div class="d-flex justify-content-end align-items-center">
                    <div v-if="data.item.editable" class="d-flex">
                      <button class="btn btn-danger btn-tiny mr-1" @click.prevent="cancelEdit(data.item.id)">Cancel</button>
                      <button class="btn btn-primary btn-tiny" @click.prevent="saveEdit(data.item.id)">Save</button>
                    </div>
                    <div v-else class="ellipsis-button">
                      <BaseDropdown right variant="link">
                        <template #button-content>
                          <i class="fa-solid fa-ellipsis"></i>
                        </template>
                        <li><a class="dropdown-item" href="#" @click.prevent="editGroupMember(data.item.id)">Edit</a></li>
                        <li v-if="canExcludeMembers || data.item.groupsurveymember_status_id < 4"><a class="dropdown-item" href="#" @click.prevent="togglegroupmember(data.item.id)">Include in this survey</a></li>
                      </BaseDropdown>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(groupmember_code)="{ data }">
                  {{ data.item.groupmember_code }}
                </template>
                <template v-slot:cell(groupmember_email)="{ data }">
                  <div>
                    <div v-if="!data.item.editable" class="uneditable" :class="{ 'g-anon': anon }">{{ data.item.groupmember_email }}</div>
                    <input v-else v-model="data.item.groupmember_email" type="text" class="form-control" :class="{ 'g-anon': anon }" />
                  </div>
                </template>
                <template v-slot:cell(groupmember_mobile)="{ data }">
                  <input v-model="data.item.groupmember_mobile" type="text" class="form-control" />
                </template>
                <template v-slot:cell(groupsurveymember_formoption_id)="{ data }">
                  <div v-if="!data.item.editable" class="uneditable">{{ getFormOptionText(data.item.groupsurveymember_formoption_id) }}</div>
                  <select
                    v-else-if="Number(data.item.groupsurveymember_status_id) === 1"
                    v-model="data.item.groupsurveymember_formoption_id"
                    class="form-select"
                  >
                    <option v-for="option in formoptions" :key="option.value" :value="option.value">{{ option.text }}</option>
                  </select>
                  <div v-else class="uneditable">{{ getFormOptionText(data.item.groupsurveymember_formoption_id) }}</div>
                </template>
              </BaseTable>
            </div>
          </div>
        </div>

        <div class="accordion full-width" role="tablist">
          <div class="card">
            <header class="p-0" role="tab">
              <button
                class="btn btn-info btn-block text-left w-100 collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#accordion-2"
                aria-expanded="false"
                aria-controls="accordion-2"
              >
                Scheduled emails
              </button>
            </header>
          </div>
          <div id="accordion-2" class="collapse" role="tabpanel">
            <div class="card-body">
              <GroupSurveyScheduledMails :surveyid="$store.state.currentsurvey.id" :changed="surveychanged" status="scheduled" />
            </div>
          </div>
        </div>

        <div class="accordion full-width" role="tablist">
          <div class="card">
            <header class="p-0" role="tab">
              <button
                class="btn btn-info btn-block text-left w-100 collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#accordion-3"
                aria-expanded="false"
                aria-controls="accordion-3"
              >
                Sent emails
              </button>
            </header>
          </div>
          <div id="accordion-3" class="collapse" role="tabpanel">
            <div class="card-body">
              <GroupSurveyScheduledMails :surveyid="$store.state.currentsurvey.id" :changed="surveychanged" status="sent" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <BaseModal
      v-model="showMemberLink"
      title="Questionnaire link and personal code"
      size="lg"
      :ok-only="true"
      ok-title="Close"
      cancel-title="Close"
    >
      <div class="mb-3">
        <textarea v-model="currentcodelink" class="form-control" rows="18" readonly></textarea>
      </div>
    </BaseModal>

    <BaseModal v-model="addingmember" :show-header="false" :show-footer="false" centered :closeable="false">
      <template #body>
        <div class="text-center p-4">
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div>Adding member...</div>
        </div>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseTable from './base/BaseTable.vue'
import BaseDropdown from './base/BaseDropdown.vue'
import BaseEditor from './base/BaseEditor.vue'
import GroupSurveyScheduledMails from './GroupSurveyScheduledMails.vue'
import { config } from '../../config'

const editortools = [
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  ['bold', 'italic'],
  [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
  [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
  [{ color: [] }],
  ['image']
]

export default {
  name: 'GroupSurveyParticipantsSection',
  components: { BaseTable, BaseDropdown, BaseEditor, GroupSurveyScheduledMails },
  props: {
    surveyStatusId: { type: Number, default: 0 },
    screentexts: { type: Array, default: () => [] },
    surveychanged: { type: Boolean, default: false }
  },
  emits: ['survey-updated'],
  data () {
    return {
      editortoolbar: editortools,
      addingmember: false,
      addmember: false,
      contactmembers: false,
      sendinvitations: false,
      invitationsSent: 0,
      groupmember_name: '',
      groupmember_email: '',
      groupmember_email_valid: null,
      groupmember_mobile: '',
      groupmember_formoption_id: 1,
      groupmembers_grid: [],
      nextid: 10000000,
      mail_subject: null,
      mail_consultant_text: '',
      mail_cc: null,
      mail_text: '',
      selected: false,
      selectedCount: 0,
      numberSelectedMembersWithEmail: 0,
      original_member_data: {},
      canExcludeMembers: true,
      showMemberLink: false,
      currentcode: '',
      currentlink: '',
      survey_invitation_subject: '',
      survey_invitation_consultant_text: '',
      survey_invitation_cc: '',
      fields: [
        { key: 'select', label: '', sortable: false, class: 'select-td', tdClass: 'editable select-td', thClass: 'select-th' },
        { key: 'groupsurveymember_survey_code', sortable: true, label: 'Code', tdClass: 'd-none d-sm-table-cell', thClass: 'd-none d-sm-table-cell' },
        { key: 'groupmember_email', label: 'Email', sortable: true, class: 'editable email-column' },
        { key: 'groupsurveymember_status_id', label: 'Status', sortable: true, class: 'editable color-input', tdClass: 'p-0', thClass: 'p-0' },
        { key: 'groupsurveymember_formoption_id', label: 'Form type', sortable: true, class: 'editable select-column' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      fieldsExclude: [
        { key: 'groupsurveymember_survey_code', label: 'Code', tdClass: 'd-none d-sm-table-cell', thClass: 'd-none d-sm-table-cell' },
        { key: 'groupmember_email', label: 'Email', class: 'editable email-column' },
        { key: 'groupsurveymember_formoption_id', label: 'Form type', class: 'editable select-column' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ]
    }
  },
  computed: {
    anon () { return this.$store.state.anon },
    formoptions () {
      return (this.$store.state.formoptions || []).map(i => ({ value: i.id, text: i.formoption_name }))
    },
    membersselected () { return this.$store.state.selectedsurveymembers || [] },
    surveymembers_reload () { return this.$store.state.surveymembers_reload },
    includedGroupMembers () {
      return this.groupmembers_grid.filter(m => Number(m.included_in_survey) === 1)
    },
    excludedGroupMembers () {
      return this.groupmembers_grid.filter(m => Number(m.included_in_survey) === 0)
    },
    plainTextInvitation () {
      return (this.$store.state.currentsurvey.survey_invitation_text || '')
        .replace(/<\/p>/g, '\n\n')
        .replace(/<br\s*\/?>/g, '\n')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
    },
    currentcodelink () {
      return this.currentlink + '\n\n' + this.currentcode + '\n\n' + this.plainTextInvitation
    }
  },
  watch: {
    surveymembers_reload () { this.surveymembers_get() },
    '$store.state.currentsurvey.survey_invitation_subject' (val) { this.survey_invitation_subject = val || '' },
    '$store.state.currentsurvey.survey_invitation_consultant_text' (val) { this.survey_invitation_consultant_text = val || '' },
    '$store.state.currentsurvey.survey_invitation_cc' (val) { this.survey_invitation_cc = val || '' }
  },
  created () {
    const s = this.$store.state.currentsurvey
    this.survey_invitation_subject = s.survey_invitation_subject || ''
    this.survey_invitation_consultant_text = s.survey_invitation_consultant_text || ''
    this.survey_invitation_cc = s.survey_invitation_cc || ''
    this.surveymembers_get()
    this.$store.dispatch('groupsurveymembers_setselected', { surveymembers: [] })
    this.countselected()
    const filter = { survey_id: { operator: '=', value: s.id } }
    this.$store.dispatch('records_readall', { table_name: 'g_gdqreports', filter })
      .then(resp => { if (resp.data.result.length) this.canExcludeMembers = false })
  },
  methods: {
    saveField (fieldname, value) {
      const data = { id: this.$store.state.currentsurvey.id, [fieldname]: value }
      this.$store.dispatch('groupsurvey_save', { survey: data })
    },
    selectall (selected) {
      this.groupmembers_grid = this.groupmembers_grid.map(member => ({
        ...member,
        selected: this.isIncluded(member) ? selected : member.selected
      }))
      this.countselected()
    },
    countselected () {
      const selectedsurveymembers = []
      let numbersel = 0
      for (let i = 0; i < this.groupmembers_grid.length; i++) {
        if (this.isIncluded(this.groupmembers_grid[i])) {
          if (this.groupmembers_grid[i].selected) {
            selectedsurveymembers.push(this.groupmembers_grid[i].id)
            numbersel++
          }
        }
      }
      this.selectedCount = numbersel
      this.selected = numbersel > 0 && numbersel === this.includedGroupMembers.length
      this.numberSelectedMembersWithEmail = this.groupmembers_grid.filter(
        member =>
          !!(member.groupmember_email && String(member.groupmember_email).trim()) &&
          Number(member.groupsurveymember_formoption_id) === 1 &&
          member.selected
      ).length
      this.$store.dispatch('groupsurveymembers_setselected', { surveymembers: selectedsurveymembers })
    },
    isIncluded (item) {
      return item && Number(item.included_in_survey) === 1
    },
    rowClass (item) {
      return item.editable ? 'editable-row' : ''
    },
    getFormOptionText (id) {
      const option = this.formoptions.find(o => Number(o.value) === Number(id))
      return option ? option.text : ''
    },
    statusBadgeClass (item) {
      if (!item) return 'badge bg-light text-dark'
      const status = Number(item.groupsurveymember_status_id)
      if (isNaN(status)) return 'status-tag bg-light border-none text-dark'
      if (status === 1) return 'status-tag bg-danger border-none text-dark'
      if (status === 2) return 'status-tag bg-light border-bottom text-dark'
      if (status === 3) return 'status-tag bg-secondary text-dark'
      if (status === 4) return 'status-tag bg-primary text-dark'
      return 'status-tag bg-light border text-dark'
    },
    statusLabel (item) {
      if (!item) return ''
      const status = Number(item.groupsurveymember_status_id)
      const formOption = Number(item.groupsurveymember_formoption_id)
      if (status === 1) {
        if (formOption === 1) return 'Not sent'
        if (formOption === 2) return 'Not printed'
        return 'Manual send'
      }
      if (status === 2) {
        if (formOption === 1) return 'Sent'
        if (formOption === 2) return 'Printed'
        return 'Manual send'
      }
      if (status === 3) return `Started (${item.gdq_answers})`
      if (status === 4) return `Completed (${item.gdq_answers})`
      return ''
    },
    editGroupMember (id) {
      for (let i = 0; i < this.groupmembers_grid.length; i++) {
        if (Number(this.groupmembers_grid[i].id) === Number(id)) {
          if (this.groupmembers_grid[i].editable) {
            this.groupmembers_grid[i].editable = false
          } else {
            this.groupmembers_grid.forEach((member, index) => {
              if (index !== i) this.cancelEdit(member.id)
            })
            this.groupmembers_grid[i].editable = true
            this.original_member_data[id] = JSON.parse(JSON.stringify(this.groupmembers_grid[i]))
          }
        }
      }
    },
    cancelEdit (id) {
      const index = this.groupmembers_grid.findIndex(m => Number(m.id) === Number(id))
      if (index !== -1 && this.original_member_data[id]) {
        const orig = this.original_member_data[id]
        Object.assign(this.groupmembers_grid[index], {
          groupsurveymember_survey_code: orig.groupsurveymember_survey_code,
          groupmember_email: orig.groupmember_email,
          groupmember_mobile: orig.groupmember_mobile,
          groupmember_formoption_id: orig.groupmember_formoption_id,
          groupsurveymember_formoption_id: orig.groupsurveymember_formoption_id,
          groupmember_status_id: orig.groupmember_status_id,
          included_in_survey: orig.included_in_survey,
          editable: false
        })
        delete this.original_member_data[id]
      }
    },
    saveEdit (id) {
      const index = this.groupmembers_grid.findIndex(m => Number(m.id) === Number(id))
      if (index !== -1) {
        const member = this.groupmembers_grid[index]
        const original = this.original_member_data[id]
        const originalEmail = original.groupmember_email || ''
        if (this.validateEditedMember(member)) {
          if (member.groupmember_email !== originalEmail) {
            member.groupsurveymember_status_id = 1
            this.groupmembers_grid[index].groupsurveymember_status_id = 1
          }
          member.editable = false
          delete this.original_member_data[id]
          this.updatesurvey(false)
        } else {
          member.groupmember_email_valid = 'invalid'
          const mail = member.groupmember_email
          member.groupmember_email = ''
          member.groupmember_email = mail
        }
      }
    },
    validateEditedMember (member) {
      if (member.groupsurveymember_formoption_id !== 1) {
        member.groupmember_email_valid = null
        member.groupmember_email = ''
        return true
      }
      return this.parse_email(member.groupmember_email)
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(email.toLowerCase())
    },
    getlink (id) {
      this.$store.dispatch('groupsurveymember_fetch', { id })
        .then(resp => {
          const data = resp?.data?.result ? resp.data.result : resp.data
          const token = data?.groupsurveymember_token || ''
          const code = data?.groupsurveymember_survey_code || ''
          this.currentlink = token ? `${config.front_url}/gdqquestionnaire/${token}` : ''
          this.currentcode = code
          this.showMemberLink = true
        })
    },
    printform (id) {
      this.$store.dispatch('paperform_fetch', { surveymember_id: id })
        .then(resp => {
          window.open(config.report_url + '/gdq_paperforms.php?i=' + resp.data.id)
        })
    },
    openquestionnaire (id) {
      this.$store.dispatch('groupsurveymember_fetch', { id })
        .then(resp => {
          const data = resp?.data?.result ? resp.data.result : resp.data
          const token = data?.groupsurveymember_token
          const code = data?.groupsurveymember_survey_code
          this.$store.dispatch('questionnaire_setadmin', { admin: true })
            .then(() => this.$store.dispatch('questionnaire_setadmin_code', { code }))
            .then(() => window.open('/gdqquestionnaire/' + token))
        })
    },
    togglegroupmember (id) {
      for (let i = 0; i < this.groupmembers_grid.length; i++) {
        if (Number(this.groupmembers_grid[i].id) === Number(id)) {
          this.groupmembers_grid[i].included_in_survey = this.isIncluded(this.groupmembers_grid[i]) ? 0 : 1
          if (!this.isIncluded(this.groupmembers_grid[i])) {
            this.groupmembers_grid[i].selected = false
          }
          this.updatesurvey(false)
        }
      }
    },
    cleargroupmember () {
      this.groupmember_name = ''
      this.groupmember_email = ''
      this.groupmember_mobile = ''
      this.groupmember_email_valid = null
    },
    validategroupmember () {
      this.groupmember_email_valid = null
      if (Number(this.groupmember_formoption_id) === 1) {
        if (!this.groupmember_email || !this.parse_email(this.groupmember_email)) {
          this.groupmember_email_valid = 'invalid'
          return false
        }
      }
      return true
    },
    addgroupmember () {
      if (this.validategroupmember()) {
        this.updatesurvey(true)
      }
    },
    toggleaddmember () {
      this.cleargroupmember()
      this.addmember = !this.addmember
      this.contactmembers = false
      this.sendinvitations = false
    },
    togglecontactmembers () {
      this.contactmembers = !this.contactmembers
      this.sendinvitations = false
      if (this.addmember) this.cleargroupmember()
      this.addmember = false
    },
    togglesendinvitations () {
      this.invitationsSent = 0
      this.sendinvitations = !this.sendinvitations
      this.contactmembers = false
      if (this.addmember) this.cleargroupmember()
      this.addmember = false
    },
    toggleSelected (id, scrollto, type) {
      for (let i = 0; i < this.groupmembers_grid.length; i++) {
        this.groupmembers_grid[i].selected = Number(this.groupmembers_grid[i].id) === Number(id)
      }
      if (type === 'invite') {
        this.sendinvitations = true
        this.contactmembers = false
        if (this.addmember) this.cleargroupmember()
        this.addmember = false
      } else if (type === 'contact') {
        this.contactmembers = true
        this.sendinvitations = false
        if (this.addmember) this.cleargroupmember()
        this.addmember = false
      }
      this.countselected()
      this.$nextTick(() => {
        setTimeout(() => {
          const element = document.getElementById(scrollto)
          if (element) element.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      })
    },
    sendemails (type) {
      const mailrecipients = []
      let send_mail_subject = ''
      let send_mail_text = ''
      let send_mail_consultant_text = ''
      let send_mail_cc = ''
      if (type === 'Invitation') {
        send_mail_subject = this.survey_invitation_subject
        send_mail_text = this.$store.state.currentsurvey.survey_invitation_text
        send_mail_consultant_text = this.survey_invitation_consultant_text
        send_mail_cc = this.survey_invitation_cc
      }
      if (type === 'Other') {
        send_mail_subject = this.mail_subject
        send_mail_text = this.mail_consultant_text
        send_mail_consultant_text = this.mail_consultant_text
        send_mail_cc = ''
      }
      for (let i = 0; i < this.$store.state.currentsurveymembers.length; i++) {
        if (this.membersselected.includes(this.$store.state.currentsurveymembers[i].id)) {
          if (Number(this.$store.state.currentsurveymembers[i].groupsurveymember_formoption_id) === 1) {
            mailrecipients.push(this.$store.state.currentsurveymembers[i])
          }
        }
      }
      const payload = {
        survey: this.$store.state.currentsurvey,
        surveymembers: mailrecipients,
        mail_subject: send_mail_subject,
        mail_text: send_mail_text,
        mail_consultant_text: send_mail_consultant_text,
        mail_cc: send_mail_cc,
        mail_type: type
      }
      this.contactmembers = false
      this.sendinvitations = false
      if (type === 'Invitation') {
        this.invitationsSent = mailrecipients.length
        this.selectall(false)
      }
      this.$store.dispatch('groupsurvey_mail', payload)
      setTimeout(() => {
        this.$emit('survey-updated')
        this.$store.dispatch('surveymembers_setreload', { reload: 1 })
      }, 1500)
    },
    async updatesurvey (adding) {
      this.addingmember = true
      try {
        if (adding) {
          const newmember = {
            newid: 0,
            id: this.nextid,
            groupmember_email: this.groupmember_email,
            groupmember_mobile: this.groupmember_mobile,
            groupmember_name: this.groupmember_name,
            groupmember_formoption_id: this.groupmember_formoption_id,
            groupsurveymember_formoption_id: this.groupmember_formoption_id,
            included_in_survey: 1
          }
          this.nextid++
          this.cleargroupmember()
          this.groupmembers_grid.push(newmember)
          const data = {
            group_id: this.$store.state.currentgroup_id,
            survey_id: this.$store.state.currentsurvey.id,
            groupmembers: this.groupmembers_grid,
            group: this.$store.state.currentgroup,
            survey: this.$store.state.currentsurvey
          }
          this.cleargroupmember()
          this.$store.dispatch('addingsurveymember_set', { addingsurveymember: true })
          await this.$store.dispatch('groupsurveymembers_create', data)
          this.surveymembers_get()
        } else {
          const savemembers = this.groupmembers_grid.map(m => ({
            newid: m.id,
            id: m.groupmember_id,
            groupmember_email: m.groupmember_email,
            groupmember_name: m.groupmember_name,
            groupmember_mobile: m.groupmember_mobile,
            groupsurveymember_formoption_id: m.groupsurveymember_formoption_id,
            groupsurveymember_status_id: m.groupsurveymember_status_id,
            included_in_survey: m.included_in_survey
          }))
          const data = {
            group_id: this.$store.state.currentgroup_id,
            survey_id: this.$store.state.currentsurvey.id,
            groupmembers: savemembers,
            group: this.$store.state.currentgroup,
            survey: this.$store.state.currentsurvey
          }
          this.cleargroupmember()
          await this.$store.dispatch('groupsurveymembers_create', data)
          this.surveymembers_get()
        }
        this.$store.dispatch('surveymembers_setreload', { reload: 1 })
      } finally {
        this.addingmember = false
      }
    },
    surveymembers_get () {
      this.$store.dispatch('groupsurveyandgroupmembers_fetch', { survey_id: this.$store.state.currentsurvey.id })
        .then(resp => {
          const groupsurveymembers = []
          for (let i = 0; i < resp.data.result.length; i++) {
            const r = resp.data.result[i]
            const fo = this.formoptions.find(f => Number(r.groupsurveymember_formoption_id) === Number(f.value))
            groupsurveymembers.push({
              id: r.id,
              groupmember_id: r.groupmember_id,
              groupsurveymember_survey_code: r.groupsurveymember_survey_code,
              groupmember_name: r.groupmember_name,
              groupmember_email: r.groupmember_email,
              groupmember_mobile: r.groupmember_mobile,
              groupsurveymember_formoption_id: Number(r.groupsurveymember_formoption_id),
              groupsurveymember_formoption_name: fo ? fo.text : 'None',
              groupsurveymember_status_id: r.groupsurveymember_status_id,
              gdq_answers: r.gdq_answers,
              included_in_survey: Number(r.included_in_survey) === 1 ? 1 : 0,
              selected: false,
              editable: false
            })
          }
          this.groupmembers_grid = groupsurveymembers
        })
    },
    copyText () {
      const editorContent = document.querySelector('#fixed-text')
      const range = document.createRange()
      range.selectNodeContents(editorContent)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
      selection.removeAllRanges()
    }
  }
}
</script>
